import { Button, Stack } from '@mui/material';

export function DateVehicleEmptyActions({
  onChooseNewDate,
  onChooseNewVehicle,
  newDateLabel,
  newVehicleLabel,
}: {
  onChooseNewDate: () => void;
  onChooseNewVehicle: () => void;
  newDateLabel: string;
  newVehicleLabel: string;
}) {
  return (
    <Stack direction="column" spacing={2} sx={{ width: '100%', mt: '5svh' }}>
      <Button
        variant="outlined"
        color="secondary"
        fullWidth
        sx={{ borderRadius: 4, color: 'secondary.main', borderColor: 'secondary.main' }}
        onClick={onChooseNewDate}
        data-qa-element-id="select_new_date_button"
      >
        {newDateLabel}
      </Button>
      <Button
        variant="contained"
        color="secondary"
        fullWidth
        sx={{ borderRadius: 4 }}
        onClick={onChooseNewVehicle}
        data-qa-element-id="select_new_target_button"
      >
        {newVehicleLabel}
      </Button>
    </Stack>
  );
}
